import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup,UntypedFormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { Value } from 'src/app/core/helpers/value-helper';
import { Contact } from 'src/app/core/models/contact.model';
import { ValidatorExt } from 'src/app/core/helpers/validators';
import { TooltipDisplayRegisterContext } from 'src/app/services/tooltip-display.types';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.css']
})
export class ContactDetailsComponent implements OnInit {

  private _readonly: boolean = false;
  private _lastNameRequired: boolean = false;
  private _lastNameBaseValidator: ValidatorFn | null = null;
  private _emailBaseValidator: ValidatorFn | null = null;

  contactFg: UntypedFormGroup = this.formBuilder.group({
    id:[0],
    firstName: [''],
    lastName: [''],
    email: [''],
    phone: [''],
    mobile: [''],
    fax:[''],
    type:['']
  });

  cardTitle: string = '';
  @Input('formGroup')
  set detailsFg(value: any) {
    this.contactFg = value;
    this.applyLastNameRequiredValidator();
    this.applyEmailFormatValidator();
    if (this._readonly) {
      this.setReadonly();
    }
  }

  @Input('isRequired') isRequired: boolean = false;
  @Input('validate') validate: boolean = false;
   @Input() tooltipContext?: TooltipDisplayRegisterContext;
  @Input('lastNameRequired')
  set lastNameRequired(value: boolean) {
    this._lastNameRequired = !!value;
    this.applyLastNameRequiredValidator();
  }
  get lastNameRequired(): boolean {
    return this._lastNameRequired;
  }
  @Input('showFax') showFax: boolean = false;
  @Input('readonly')
  set readonly(value: boolean) {
    this._readonly = !!value;
    if (this._readonly) {
      this.setReadonly();
    }
  }
  get readonly(): boolean {
    return this._readonly;
  }
  @Input('layout') layout: string = "vertical";
  
  @Input('title')
  set cardTitleName(value: any) {
    this.cardTitle = value;
  }
  constructor(private formBuilder:UntypedFormBuilder) { }

  ngOnInit() {
    this.applyLastNameRequiredValidator();
    this.applyEmailFormatValidator();
  }

  generateFormGroup() {
    this.contactFg = this.formBuilder.group({
      id: [0],
      firstName: [''],
      lastName: [''],
      email: [''],
      phone: [''],
      mobile:[''],
      fax:[''],
      type:['']
    });
  }

  getContact(): Contact {
    return this.contactFg.value as Contact;
  }

  setContact(contact: Contact) {
    if (this.contactFg == null || this.contactFg == undefined) this.generateFormGroup();
    this.contactFg.patchValue({
      id: contact.id,
      firstName: contact.firstName,
      lastName: contact.lastName,
      email: contact.email,
      phone: contact.phone,
      mobile: contact.mobile,
      fax:contact.fax,
      type:contact.type
    });
  }

  public patchValue(contact: Contact) {
    if (this.contactFg == null || this.contactFg == undefined) return;
    if (contact == null || contact == undefined) {
      this.contactFg.reset({
        id: 0
      });
    } else {
      this.contactFg.patchValue(contact);
    }
    // Mark all as touched after patching values to show validation errors
    this.contactFg.markAllAsTouched();
  }

  public get formValue(): {} {
    return this.contactFg.value;
  }

  public get isFormValid(): boolean {

    if (Value.IsNullOrUndefined(this.contactFg)) {
       return false;
    }      
    return this.contactFg.valid;
  }

  public setReadonly() {
    if (Value.IsNullOrUndefined(this.contactFg)) return;

    this.contactFg.get('firstName')?.disable();
    this.contactFg.get('lastName')?.disable();
    this.contactFg.get('phone')?.disable();
    this.contactFg.get('mobile')?.disable();
    this.contactFg.get('email')?.disable();
    this.contactFg.get('fax')?.disable();
    this.contactFg.get('id')?.disable();
    this.contactFg.get('type')?.disable();
  }

  private applyLastNameRequiredValidator() {
    if (Value.IsNullOrUndefined(this.contactFg)) return;

    const lastNameControl = this.contactFg.get('lastName');
    if (!lastNameControl) return;

    if (this._lastNameBaseValidator === null) {
      this._lastNameBaseValidator = lastNameControl.validator;
    }

    if (this._lastNameRequired) {
      const validators = [this._lastNameBaseValidator, Validators.required].filter(v => !!v) as ValidatorFn[];
      lastNameControl.setValidators(validators);
    } else {
      lastNameControl.setValidators(this._lastNameBaseValidator);
    }

    lastNameControl.updateValueAndValidity({ emitEvent: false });
  }

  private applyEmailFormatValidator() {
    if (Value.IsNullOrUndefined(this.contactFg)) return;

    const emailControl = this.contactFg.get('email');
    if (!emailControl) return;

    if (this._emailBaseValidator === null) {
      this._emailBaseValidator = emailControl.validator;
    }

    const validators = [this._emailBaseValidator, ValidatorExt.validateEmail()].filter(v => !!v) as ValidatorFn[];
    emailControl.setValidators(validators);
    emailControl.updateValueAndValidity({ emitEvent: false });
  }

}
